import SalesCardLoadingPlaceholder from "../../sales/SalesCardLoadingPlaceholder";
import SalesPageLoading from "../../sales/SalesPageLoading";

const RedirectPage = ({ week, isToUseAuthZero, isAuthenticated, logoutUrl }) => {
  return (
    <SalesPageLoading
      week={week}
      isToUseAuthZero={isToUseAuthZero}
      isAuthenticated={isAuthenticated}
      logoutUrl={logoutUrl}
    >
      <SalesCardLoadingPlaceholder></SalesCardLoadingPlaceholder>
      <SalesCardLoadingPlaceholder></SalesCardLoadingPlaceholder>
      <SalesCardLoadingPlaceholder></SalesCardLoadingPlaceholder>
    </SalesPageLoading>
  );
};

export default RedirectPage;
